import { Component, ErrorInfo, ReactNode } from 'react'
import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { trackException } from '../../apis/appInsights'

type Props = {
  children: ReactNode
  fallback?: ReactNode
  // Changing this clears a caught error, e.g. the route, so navigating away
  // from a crashed page renders the app again.
  resetKey?: unknown
}

type State = {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    trackException(
      error,
      { componentStack: info.componentStack },
      SeverityLevel.Critical
    )
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null
    }

    return this.props.children
  }
}

export default ErrorBoundary
